import { render, staticRenderFns } from "./HelpMain.vue?vue&type=template&id=6f05e507&"
import script from "./HelpMain.vue?vue&type=script&lang=js&"
export * from "./HelpMain.vue?vue&type=script&lang=js&"
import style0 from "./HelpMain.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports